"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StorefrontFilters = _interopRequireDefault(require("../../records/StorefrontFilters"));

var RequestKey = _interopRequireWildcard(require("../../constants/RequestKey"));

var FilterKey = _interopRequireWildcard(require("../../constants/search/FilterKey"));

var SortField = _interopRequireWildcard(require("../../constants/search/SortField"));

var _requestState = require("../../utils/requestState");

var DetailsActions = _interopRequireWildcard(require("../../actions/DetailsActions"));

var _urls = require("../../utils/urls");

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _MainSection = require("../layout/MainSection");

var _MainSectionInner = _interopRequireDefault(require("../layout/MainSectionInner"));

var _MainSectionHeading = _interopRequireDefault(require("../layout/MainSectionHeading"));

var _InnerSection = _interopRequireDefault(require("../layout/InnerSection"));

var _ResultsGrid = _interopRequireDefault(require("../storefront/results/ResultsGrid"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var MoreApps = function MoreApps(_ref) {
  var category = _ref.category,
      fetchMoreApps = _ref.fetchMoreApps,
      moreAppsHasCategoryResults = _ref.moreAppsHasCategoryResults,
      moreAppsRequestState = _ref.moreAppsRequestState,
      moreAppsResults = _ref.moreAppsResults,
      resetMoreApps = _ref.resetMoreApps,
      superCategory = _ref.superCategory,
      slug = _ref.slug,
      trackInteraction = _ref.trackInteraction;
  var moreAppsQueries = (0, _react.useMemo)(function () {
    var _merge, _merge2;

    return [new _StorefrontFilters.default().merge((_merge = {}, (0, _defineProperty2.default)(_merge, FilterKey.CATEGORY, category), (0, _defineProperty2.default)(_merge, FilterKey.SORT_FIELD, SortField.RANDOM), _merge)).toSearchQuery({
      length: 4,
      nextSearchMaxTrigger: 0
    }), new _StorefrontFilters.default().merge((_merge2 = {}, (0, _defineProperty2.default)(_merge2, FilterKey.SUPER_CATEGORY, superCategory), (0, _defineProperty2.default)(_merge2, FilterKey.SORT_FIELD, SortField.RANDOM), _merge2)).toSearchQuery({
      length: 4
    })];
  }, [category, superCategory]);
  (0, _react.useEffect)(function () {
    if ((0, _requestState.isUninitialized)(moreAppsRequestState) && category && superCategory) {
      fetchMoreApps(moreAppsQueries, slug);
    }
  }, [category, fetchMoreApps, moreAppsRequestState, moreAppsQueries, slug, superCategory]);
  (0, _react.useEffect)(function () {
    return function () {
      return resetMoreApps();
    };
  }, [resetMoreApps]);
  return (0, _requestState.isSucceeded)(moreAppsRequestState) && moreAppsResults.size && _react.default.createElement(_MainSection.DetailMainSection, {
    color: "light"
  }, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_MainSectionHeading.default, {
    itemRight: _react.default.createElement(_UIRouterLink.default, {
      onClick: function onClick() {
        trackInteraction('click more apps see all link', 'more apps');
      },
      to: moreAppsHasCategoryResults ? (0, _urls.getCategoryFilterUrl)(category, superCategory) : (0, _urls.getSuperCategoryFilterUrl)(superCategory)
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.detail.moreApps.seeAllLinkText"
    }))
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.moreApps.headingText",
    options: {
      category: (0, _unescapedText.default)(moreAppsHasCategoryResults ? (0, _i18n.getCategoryI18nKey)(category) : (0, _i18n.getSuperCategoryI18nKey)(superCategory))
    }
  })), _react.default.createElement(_InnerSection.default, null, _react.default.createElement(_ResultsGrid.default, {
    onResultClick: function onResultClick() {
      trackInteraction('click more apps result item', 'more apps');
    },
    requestState: moreAppsRequestState,
    results: moreAppsResults
  }))));
};

MoreApps.propTypes = {
  category: _propTypes.default.string.isRequired,
  fetchMoreApps: _propTypes.default.func.isRequired,
  resetMoreApps: _propTypes.default.func.isRequired,
  slug: _propTypes.default.string.isRequired,
  superCategory: _propTypes.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    moreAppsResults: state.details.getIn(['moreApps', 'results']),
    moreAppsHasCategoryResults: state.details.getIn(['moreApps', 'hasCategoryResults']),
    moreAppsRequestState: state.requestStates[RequestKey.DETAILS_MORE_APPS_FETCH]
  };
};

var mapDispatchToProps = {
  fetchMoreApps: DetailsActions.fetchMoreApps,
  resetMoreApps: DetailsActions.resetMoreApps
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MoreApps);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/MoreApps.js
// module id = 878
// module chunks = 209 210 211 212